concourse-panzoom {
  width: 100%;
  height: 100%;
  display: block;
}

.discipline-row {
  cursor: default;
}

.discipline-editing-input {
  font-family: inherit;
}

.discipline-toolbar-container {
  pointer-events: all;
}

.add-discipline-placeholder,
.add-new-page-placeholder {
  cursor: pointer;
}

.add-discipline-placeholder:hover rect,
.add-new-page-placeholder:hover rect {
  stroke: var(--ion-color-primary);
  stroke-width: 3;
}

.add-discipline-placeholder:hover text,
.add-new-page-placeholder:hover text {
  fill: var(--ion-color-primary);
}
